import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@scentregroup/ui'
import { makeMailUrl } from '../../helpers'
import { centreType } from '../../types'
import ExternalLink from '../external-link'
import Footer from '../footer'
import WestfieldPlusJoinNow from '../westfield-plus-join-now'
import style from './index.module.scss'

function CentreFooter({ centre }) {
  return (
    <Footer>
      <div className={style.location}>
        <div className={style.centreName}>Westfield {centre.title}</div>
        <div className={style.centreAddress}>
          {centre.physicalAddress} <br />
          {centre.suburb} {centre.state} {centre.postcode} <br />
          <ExternalLink url={`tel:${centre.telephoneNumber}`}>
            {centre.telephoneNumber}
          </ExternalLink>
        </div>
        <ExternalLink
          url={makeMailUrl(centre.emailAddress)}
          className={style.contactConcierge}
        >
          {`Contact ${centre.title} Concierge`}
        </ExternalLink>
        <Link to="/" className={style.centreChangeLink}>
          Change Centre
        </Link>
      </div>
      <div className={style.contactSection}>
        <div className={style.contactLinks} data-test-id="contact-links">
          {centre.emailAddress && (
            <ExternalLink url={makeMailUrl(centre.emailAddress)}>
              <Icon type="email" size="medium" className={style.socialLogo} />
            </ExternalLink>
          )}
          {centre.contactLinks.map(
            contact =>
              contact.url && (
                <ExternalLink url={contact.url} key={contact.type}>
                  <Icon
                    type={contact.type}
                    size="medium"
                    className={style.socialLogo}
                  />
                </ExternalLink>
              )
          )}
        </div>
        <WestfieldPlusJoinNow />
      </div>
    </Footer>
  )
}

CentreFooter.propTypes = {
  centre: centreType,
}

export default CentreFooter
